export type ClassroomIdea = {
  title: string;
  body: string;
  imageSrc: string;
  imageAlt: string;
  /**
   * Absolute positioning for the peeking character over the card.
   * Desktop (`md:`) values are the tuned source of truth.
   * Base (mobile) offsets are those values × (320/390) so placement/scale
   * shrinks in proportion with the narrower card.
   */
  imageClassName: string;
  /** Card tilt / alignment classes. */
  cardClassName: string;
};

export const classroomIdeas: ClassroomIdea[] = [
  {
    title: "Free choice Friday",
    body: "Hopping onto PlayMath.org has been a popular choice, both for students and teachers.",
    imageSrc: "/images/marketing/educators/inTheClassroom/activity-choice.webp",
    imageAlt: "",
    imageClassName:
      "absolute -top-[1.93rem] -left-[0.72rem] w-[38%] max-w-[115px] md:-top-[2.35rem] md:-left-3.5 md:max-w-[140px] z-10 pointer-events-none select-none",
    cardClassName: "md:mr-auto md:-translate-x-3 md:-rotate-2",
  },
  {
    title: "Lesson Warmup",
    body: "Display a game to the class and have students work together to discuss and complete it.",
    imageSrc: "/images/marketing/educators/inTheClassroom/activity-warmup.webp",
    imageAlt: "",
    imageClassName:
      "absolute -top-[2.26rem] -right-[1.64rem] w-[44%] max-w-[123px] md:-top-11 md:-right-8 md:max-w-[150px] z-10 pointer-events-none select-none",
    cardClassName: "md:ml-auto md:translate-x-3 md:rotate-2",
  },
  {
    title: "Fast Finishers",
    body: "Keep the accelerating students engaged with math-based fun.",
    imageSrc: "/images/marketing/educators/inTheClassroom/activity-finishers.webp",
    imageAlt: "",
    imageClassName:
      "absolute -top-[3.94rem] left-1/2 -translate-x-1/2 w-[36%] max-w-[107px] md:-top-[4.8rem] md:max-w-[130px] z-10 pointer-events-none select-none",
    // Off-center left, but inward from card 1’s edge position
    cardClassName: "md:mr-auto md:translate-x-16 md:-rotate-1",
  },
  {
    title: "Math Chat",
    body: "Pair up students for a two-minute strategy discussion before they attempt a level together.",
    imageSrc: "/images/marketing/educators/inTheClassroom/activity-mathchat.webp",
    imageAlt: "",
    imageClassName:
      "absolute -top-[8.82rem] right-[0.41rem] w-[42%] max-w-[123px] md:-top-[10.75rem] md:right-2 md:max-w-[150px] z-10 pointer-events-none select-none",
    // Off-center right, but inward from card 2’s edge position
    cardClassName: "md:ml-auto md:-translate-x-16 md:rotate-2",
  },
];
